import { render, staticRenderFns } from "./PolicyType5.vue?vue&type=template&id=3b640700&scoped=true"
import script from "./PolicyType5.vue?vue&type=script&lang=js"
export * from "./PolicyType5.vue?vue&type=script&lang=js"
import style0 from "./PolicyType5.vue?vue&type=style&index=0&id=3b640700&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b640700",
  null
  
)

export default component.exports